export default function getDate(format, inputDate) {
  let fecha;

  if (inputDate) {
    fecha = new Date(inputDate);
  } else {
    fecha = new Date();
  }

  const day = fecha.getDate().toString().padStart(2, '0');
  const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
  const year = fecha.getFullYear();

  if (format === 'yyyy/mm/dd') {
    return `${year}/${month}/${day}`;
  } else if (format === 'dd/mm/yyyy') {
    return `${day}/${month}/${year}`;
  } else {
    throw new Error('Format not supported');
  }
}
